import { Select } from "antd"
import { buildLaborRateOptions } from "./customLaborRateModel"
import { useContext } from "react"
import { ItemsContext } from "../ItemsRoot"

export type Props = {
  workareaId: number
  selectedCatalogItemId?: number | null
  onChange: (catalogItemId: number | null) => void
}

const CustomLaborRateSelector = ({workareaId, selectedCatalogItemId, onChange}: Props) => {
  const { jobItemsQuery, jobData } = useContext(ItemsContext)
  const options = buildLaborRateOptions({
    estimatedItems: jobItemsQuery.data?.estimatedItems.filter(x => x.workareaId === workareaId) ?? [],
    actualItems: jobItemsQuery.data?.actualItems.filter(x => x.workareaId === workareaId) ?? [],
    catalogItems: jobItemsQuery.data?.catalogItems ?? [],
    templateItems: []
  }, jobData.budgets)

  const getSelectedValue = () => {
    if (selectedCatalogItemId && !isNaN(selectedCatalogItemId)) {
      return selectedCatalogItemId
    }
    return options[0].value
  }

  return <Select
    style={{width: '100%'}}
    value={getSelectedValue()}
    options={options}
    onChange={x => onChange(x < 0 ? null : x)}
  />
}

export default CustomLaborRateSelector